import Quill from 'quill';
import { Config } from '../quill.interface';

export default class MultiplePlaceholders {
  options: Config;
  quill: Quill;

  constructor(quillEditor: Quill, options: Config) {
    this.options = options;
    this.quill = quillEditor;

    // Less than 2 placeholder / No placeholder, hiding select
    if (!this.options.content?.placeholders || this.options.content?.placeholders.length < 2) {
      return;
    }

    const container = MultiplePlaceholders._container(this.options.identifier);
    const toolbar = MultiplePlaceholders._toolbar(container);
    const span = MultiplePlaceholders._span();
    const svg = MultiplePlaceholders._svg();
    const spanArrowDropdown = MultiplePlaceholders._spanArrowDropdown();
    const select = MultiplePlaceholders._select();
    spanArrowDropdown.appendChild(svg);
    span.appendChild(select);
    span.appendChild(spanArrowDropdown);
    toolbar.appendChild(span);
    this.options.content.placeholders?.forEach(placeholder => {
      select.appendChild(MultiplePlaceholders._options(placeholder));
    });

    select.addEventListener('change', (event: Event) => {
      const input = container.querySelector('.ql-editor');
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      input.setAttribute('data-placeholder', event.target.value);
    });
  }

  private static _container(identifier: string): HTMLElement {
    return document.getElementById(identifier);
  }

  private static _toolbar(container: HTMLElement): Element {
    return container.getElementsByClassName('ql-toolbar')[0];
  }

  private static _span(): HTMLSpanElement {
    const span = <HTMLSpanElement>document.createElement('span');
    span.setAttribute('class', 'ql-formats ql-placeholder');
    return span;
  }

  private static _select(): HTMLSelectElement {
    const select = <HTMLSelectElement>document.createElement('select');
    select.setAttribute('class', 'ql-placeholder-select');
    return select;
  }

  private static _spanArrowDropdown(): HTMLSpanElement {
    const span = <HTMLSpanElement>document.createElement('span');
    span.setAttribute('class', 'ql-arrowDropdown');
    return span;
  }

  private static _svg(): SVGElement {
    const svg = <SVGElement>document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    const polygonA = <SVGPolygonElement>document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
    const polygonB = <SVGPolygonElement>document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
    polygonA.setAttribute('class', 'ql-stroke');
    polygonB.setAttribute('class', 'ql-stroke');

    polygonA.setAttribute('points', '7 11 9 13 11 11 7 11');
    polygonB.setAttribute('points', '7 7 9 5 11 7 7 7');

    svg.setAttribute('viewbox', '0 0 18 18');
    svg.appendChild(polygonA);
    svg.appendChild(polygonB);
    return svg;
  }

  private static _options(placeholder: string): HTMLOptionElement {
    const option = <HTMLOptionElement>document.createElement('option');
    option.setAttribute('value', placeholder);
    option.textContent = placeholder;
    return option;
  }
}
